module.exports = __webpack_public_path__ + "static/media/Booklet-Nutrition.a9079fa8.pdf";